import React from 'react';
import { sanitizeUrl } from '../../../../../shared/utils/sanitizationUtils';

function isValidHttpUrl(string) {
    let url;

    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }

    return url.protocol === 'http:' || url.protocol === 'https:';
}

export default function TableValueElement({ value }: { value: any }) {
    if (typeof value === 'boolean') {
        return <span>{String(value)}</span>;
    }
    if (typeof value === 'string') {
        if (isValidHttpUrl(value)) {
            const safeUrl = sanitizeUrl(value);
            return safeUrl ? <a href={safeUrl}>{value}</a> : <span>{value}</span>;
        }
        return <span>{value}</span>;
    }
    if (typeof value === 'number') {
        return <span>{value}</span>;
    }
    return null;
}
